import React, { useState } from 'react';

function EventDetail({ show, event, onClose }) {
  const [studentId, setStudentId] = useState('');
  const [studentName, setStudentName] = useState('');
  const [studentEmail, setStudentEmail] = useState('');
  const [message, setMessage] = useState('');

  if (!show || !event) return null;

  const studentIdRegex = /^[BMDIJ]\d{9}$/;
  const nameRegex = /^[\u4E00-\u9FA5A-Za-z\s]+$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const handleReserve = async () => {
  if (!studentIdRegex.test(studentId)) {
    setMessage('學號格式錯誤，請輸入有效的學號 (Invalid Student ID format, please enter a valid ID)');
    return;
  }
  if (!nameRegex.test(studentName)) {
    setMessage('姓名格式錯誤，僅能包含中文或英文 (Invalid Name format, only Chinese or English characters are allowed)');
    return;
  }
  if (!emailRegex.test(studentEmail)) {
    setMessage('Email 格式錯誤 (Invalid Email format)');
    return;
  }

try {
  const res = await fetch('http://140.117.214.67:3000/api/reservations', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ eventId: event.id, studentId, studentName, studentEmail })
  });
  const data = await res.json();
  if (res.ok) {
    setMessage('預約成功！(Compelete!!)');
  } else {
    setMessage(`預約失敗：${data.error || data.message} (Reservation failed: ${data.error || data.message})`);
  }
} catch (err) {
  setMessage('預約時發生錯誤 (An error occurred while making the reservation)');
}

  };

  return (
    <>
      <div className="modal fade show" style={{ display: 'block' }} role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{event.name}</h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>
            <div className="modal-body">
              <p>日期(Date)：{event.date}</p>
              <p>時間(Time)：{event.startTime} ~ {event.endTime}</p>
              <div className="mb-3">
                <label className="form-label">學號(Student ID)：</label>
                <input
                  className="form-control"
                  value={studentId}
                  onChange={e => setStudentId(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">姓名(Name)：</label>
                <input
                  className="form-control"
                  value={studentName}
                  onChange={e => setStudentName(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email：</label>
                <input
                  className="form-control"
                  type="email"
                  value={studentEmail}
                  onChange={e => setStudentEmail(e.target.value)}
                />
              </div>
              {message && <p className="text-danger mt-2">{message}</p>}
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={handleReserve}>送出(Submit)</button>
              <button className="btn btn-secondary" onClick={onClose}>關閉(Close)</button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
}

export default EventDetail;
